import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

// Open a payment for one credit pack. The request names *which*
// product and never what it costs: the
// price and the credits it is worth are read from the server's own catalogue and written into the
// payment before the player is sent to the provider, so the browser cannot name its own reward.
//
// `waive_withdrawal` is the checkbox's value (immediate delivery, no 14-day right of
// withdrawal); the checkout also blocks the buttons until it is ticked, and the server refuses an order
// without it (`WithdrawalWaiverRequired`). `language` is for the emailed receipt.
//
// No `onSucceed`. Nothing is stored — the id goes straight back to the provider's button, and the
// balance does not move until the capture. An order in the store would be a purchase the UI could
// show as pending when nothing has been paid.
export const thunk = createAsyncThunk("economy/createOrder", async ({ product, language, waiveWithdrawal }, { rejectWithValue }) => {
  try {
    const response = await apiClient.post("/shop/orders/", { product, waive_withdrawal: waiveWithdrawal === true, language })
    return { orderId: response.data.order_id, approveUrl: response.data.approve_url }
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = null

const thunkObject = { thunk, onSucceed }
export default thunkObject
